module.exports = __webpack_public_path__ + "img/1-02.a731f615.png";